export const BILLING_TYPES = {
    UPDATE_CLAIM_LEVEL_BILLING_STATUS: "UPDATE_CLAIM_LEVEL_BILLING_STATUS",
    GET_BILLING_AGING_REPORT: "GET_BILLING_AGING_REPORT",
    SAVE_BILLING_AGING_REPORT: "SAVE_BILLING_AGING_REPORT",
    SAVE_AGING_LADING: "SAVE_AGING_LADING",
    SAVE_AGING_FILTERS_TYPE: "SAVE_AGING_FILTERS_TYPE",
    SAVE_ONLY_AGING_FILTERS: "SAVE_ONLY_AGING_FILTERS"
}